import config from '@/config'

const isDev = config.BUILD_ENV === 'dev'

const devIds = ['100000725', '168', '235', '1', '17', '14', '100005902', '100005900', '168']
const prodIds = [
  '25332',
  '10',
  '817',
  '394',
  '148513',
  '28356',
  '17757',
  '928',
  '6263',
  '1221',
  '163261'
]

const useHasCustomCompanyPage = (companyId: string) => {
  const ids = isDev ? devIds : prodIds
  return ids.includes(companyId)
}

export default useHasCustomCompanyPage
